<template>
    <div class="card">
        <Toast />
        <form>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <h5>{{ $t('Generals.Edit.Header') }}</h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Generals.Edit.Title') }}</label>
                            <InputText type="text" :placeholder="$t('Generals.Edit.Title')" id="title2" v-model="mydata.title" disabled="disabled"></InputText>
                        </div>
                    </div>
                </div>
                <div class="p-col-12" id="desc">
                    <label for="title2" id="desctitle">{{ $t('Generals.Edit.Desc') }}</label>
                    <div class="textbox" :style="error?.information_description ? 'border: 3px solid red; border-radius: 5px' : ''">
                        <RichEditor v-model="information_description" :set-content="mydata.content" data-placeholder="$t('Generals.Edit.Description')" />
                        <!-- <Quill-Editor style="height: 230px" v-model:content="modelname" ref="myQuillEditor" :options="editorOption" contentType="html" /> -->
                        <!-- <Textarea type="text" :placeholder="$t('Generals.Edit.Description')" id="areatext" v-model="content"  @keydown.space="preventLeadingSpace" /> -->
                    </div>
                    <div class="text-red">{{ error.information_description }}</div>
                </div>
            </div>
            <br /><br />
            <div class="p-d-flex p-jc-end p-ai-center" style="float: left">
                <ConfirmPopup group="popup"></ConfirmPopup>
                <Button :label="$t('Generals.Edit.Save')" icon="pi pi-check" iconPos="left" class="p-button p-button p-mr-2 p-mb-2" @click="confirm($event)" id="save"></Button>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center" style="float: right; margin-top: 4px">
                <Button :label="$t('Generals.Edit.Back')" icon="pi pi-replay" iconPos="left" class="p-button p-button-outlined p-button p-mr-2 p-mb-2" @click="$router.go(-1)" style="background: white; color: black"> </Button>
            </div>
            <br /><br />
        </form>
    </div>
</template>
<script>
// import validateEditUser from '../../validations/user/validateEditUser';
import ValidateEditGeneral from '../../validations/General/ValidateEditGeneral';
import GeneralService from '../../service/API/GeneralService';
import moment from 'moment';
import RichEditor from '../../components/RichEditor.vue';
export default {
    components: {
        RichEditor,
    },
    data() {
        return {
            dropdownValues: [{ name: 'active' }, { name: 'inactive' }],
            dropdownItem: null,
            // modelname: JSON.parse(localStorage.getItem('desc')).content,

            mydata: {
                update_key: '',
                title: '',
                content: '',
            },
            information_description: '',
            error: {},
        };
    },
    created() {
        this.generalService = new GeneralService();
    },
    methods: {
        extractTextFromHTML(html) {
            const element = document.createElement('div');
            element.innerHTML = html;

            // Recursive function to traverse the DOM tree
            function traverse(node, result = '') {
                const children = node.childNodes;

                for (let i = 0; i < children.length; i++) {
                    const child = children[i];

                    if (child.nodeType === Node.TEXT_NODE) {
                        result += child.textContent;
                    } else if (child.nodeType === Node.ELEMENT_NODE) {
                        if (child.style.display !== 'none') {
                            result += traverse(child);
                        }
                    }
                }

                return result;
            }

            return traverse(element);
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        cancel() {
            // this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            setTimeout(() => {
                this.$router.go(-1);
            }, 2000);
        },
        preventLeadingSpace(e) {
            // only prevent the keypress if the value is blank
            if (!e.target.value) e.preventDefault();
            // otherwise, if the leading character is a space, remove all leading white-space
            else if (e.target.value[0] == ' ') e.target.value = e.target.value.replace(/^\s*/, '');
        },
        SubmitForm() {},
        confirm(event) {
            // confirm($event)

            // alert(this.mydata.notice_id)
            this.$confirm.require({
                target: event.currentTarget,
                group: 'popup',
                message: '진행하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    let vcheckData = {
                        information_description: this.extractTextFromHTML(this.information_description).trim(),
                    };
                    const { isInvalid, error } = ValidateEditGeneral(vcheckData);
                    if (isInvalid) {
                        this.error = error;
                        console.log(error);
                    } else {
                        this.generalService.editGeneral({ update_key: this.$route.params.update_key, information_description: this.information_description }).then((res) => {
                            console.warn(res);
                            localStorage.removeItem('information_description');
                            this.$router.push({ name: 'General' });
                            setTimeout(() => {
                                this.$toast.add({ severity: 'success', summary: '업데이트됨', detail: '일반 목록이 성공적으로 업데이트되었습니다.', life: 3000 });
                            }, 500);
                        });
                    }
                },
                reject: () => {
                    // this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
                },
            });
        },
        addDay(val) {
            const date = new Date(val);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (val = yyyy + '.' + mm + '.' + dd);
        },
        dateformat(value) {
            if (value) {
                return moment(String(value)).format('YYYY/MM/DD');
            }
        },
    },
    mounted() {
        this.generalService.viewGeneral(this.$route.params.update_key).then((result) => {
            this.mydata.title = result[0].title;
            this.mydata.content = result[0].content;
            this.information_description = result[0].content;
            // localStorage.setItem('desc', result[0].content);
            console.log(result);
        });
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}

input#title2 {
    background-color: lavender;
}

#areatext {
    height: 34vh;
}
.textbox {
    margin-top: 12px;
}
button#save {
    color: white;
    background: black;
}
div#desc {
    margin-top: -17px;
}
</style>
